import { useState } from 'react';
import { authStaff } from "../../../utils/constants";
import { accessFileRequest } from "../../../Requests/getRequests";
import { Loader, PhotoModal, FileModal } from "../../../components";
import { useDispatch, useSelector } from "react-redux";
import { selectAccessToken } from "../../../slices/staffSlice";
import { show } from '../../../slices/toastSlice';
import { useNavigate } from 'react-router-dom';
import { HugeiconsIcon } from '@hugeicons/react';
import { Download01Icon, EyeIcon } from '@hugeicons/core-free-icons';

function ClientFile({ loanId, file, phone, name }) {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const fileExt = file.split(".").pop();
    const fileExtensions = ['pdf', 'doc', 'docx', 'xls', 'xlsx'];

    const accessToken = useSelector(selectAccessToken);
    const [isFileOpen, setIsFileOpen] = useState(false);
    const [imageSrc, setImageSrc] = useState('');
    const [isOpen, setIsOpen] = useState(false);
    const [loading, isLoading] = useState(false);

    function closeFileModal() { setIsFileOpen(false); }
    function closeModal() { setIsOpen(false); }

    const getUrl = async () => {
        isLoading(true);
        const url = name !== "Client" ? `/loans/staff/getFile` : `/auth/client/getFile`;
        let res = await accessFileRequest(url, authStaff(accessToken), { loanId, name: file, phone });
        isLoading(false);

        if (res?.code === 401) {
            sessionStorage.clear();
            navigate("/login");
            dispatch(show({ type: "error", state: true, message: "Your session has expired. Please login to continue." }));
            return;
        }
        if (res?.err) {
            dispatch(show({ type: "error", state: true, message: res?.err }));
            return;
        }

        const fileUrl = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement('a');
        link.href = fileUrl;
        const disposition = res.headers?.['content-disposition'];
        const fileName = disposition ? disposition.split('filename=')[1].replace(/["']/g, '') : file;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        const extension = fileName.split('.').pop();

        if (fileExtensions.includes(extension)) {
            link.click();
            link.remove();
        } else {
            setImageSrc(fileUrl);
            setIsOpen(!isOpen);
        }
    };

    const isDoc = fileExtensions.includes(fileExt);

    return (
        <tr className="hover:bg-gray-50/50 dark:hover:bg-gray-700/30 transition-colors">
            <td className="px-5 py-3.5 text-sm text-gray-700 dark:text-gray-300">{file}</td>
            <td className="px-5 py-3.5 text-right">
                <div className="inline-flex items-center justify-end gap-2">
                    {loading && <Loader color="text-gray-400" size="w-4 h-4" />}
                    <button
                        type="button"
                        onClick={getUrl}
                        className="inline-flex items-center gap-1.5 text-sm font-medium text-[#1e3a6e] dark:text-blue-400 hover:text-[#264d91] dark:hover:text-blue-300 transition-colors"
                    >
                        <HugeiconsIcon icon={isDoc ? Download01Icon : EyeIcon} size={14} />
                        {isDoc ? 'Download' : 'View'}
                    </button>
                </div>
            </td>
            <td className="hidden">
                <FileModal isOpen={isFileOpen} closeModal={closeFileModal} />
            </td>
            <td className="hidden">
                <PhotoModal imageUrl={imageSrc} isOpen={isOpen} closeModal={closeModal} />
            </td>
        </tr>
    );
}

export default ClientFile;
